let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c8G9N")).then(() => parcelRequire('dqid6'));